import register from '../../../../global/js/registry';
export default register('o-shop-filter-stage', () => import(/* webpackMode: "lazy" */ './o-shop-filter-stage.controller'));
